import { FC } from 'react'
import { ObjectiveInput } from '../../../types'
import { getObjectiveAttachmentHref } from '../../../modules/meeting/util/hrefUtils'
import { useObjectiveAttachmentHelper, atobUtf8 } from '../../../shared/useObjectiveAttachmentHelper'
import './index.less'

interface ObjectiveDownloadButtonProps {
  objective: ObjectiveInput
  employeeIdOfMeetingNotLoggedInEmployeeId: string
}

export const ObjectiveDownloadButton: FC<ObjectiveDownloadButtonProps> = ({ objective, employeeIdOfMeetingNotLoggedInEmployeeId }) => {
  const { extractHumanReadableFileName } = useObjectiveAttachmentHelper(atobUtf8)
  return (
    <>
      {objective.attachment && objective.attachmentDownloadToken && (
        <a
          className={'per-btn per-btn--primary per-btn--pastel attachment-file'}
          download={extractHumanReadableFileName(objective.attachment)}
          href={getObjectiveAttachmentHref(
            employeeIdOfMeetingNotLoggedInEmployeeId,
            objective.attachment,
            objective.attachmentDownloadToken,
          )}
        >
          <span>{extractHumanReadableFileName(objective.attachment)}</span>
        </a>
      )}
    </>
  )
}
